module.exports = __webpack_public_path__ + "img/dental-pro.41fe50bd.png";